import { render } from "./SemakanSptb.vue?vue&type=template&id=64fccd62"
import script from "./SemakanSptb.vue?vue&type=script&lang=js"
export * from "./SemakanSptb.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__